"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
require("./Header.scss");
var _checkForThemeProps = require("../../utils/checkForThemeProps");
var _useStyles = _interopRequireDefault(require("../../utils/hooks/useStyles"));
var _formatSpecialCharText = _interopRequireDefault(require("../../utils/formatSpecialCharText"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const Header = _ref => {
  let {
    contentfulId,
    eyebrow,
    headline,
    subhead,
    theme,
    centered = false,
    isPageHeader = false
  } = _ref;
  const themes = (0, _checkForThemeProps.checkForThemeProps)(theme);
  const {
    backgroundColor,
    color
  } = (0, _useStyles.default)(themes);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: `ter-header ${centered ? "ter-header--centered" : ""}`,
    style: {
      color: color,
      background: backgroundColor
    },
    "data-sb-object-id": contentfulId ? contentfulId : null
  }, (eyebrow || headline || subhead) && /*#__PURE__*/_react.default.createElement("div", {
    className: "ter-header__container"
  }, eyebrow && /*#__PURE__*/(0, _react.createElement)(isPageHeader ? 'h1' : 'h2', {
    className: 'eyebrow',
    'data-sb-field-path': 'eyebrow'
  }, eyebrow), headline && /*#__PURE__*/(0, _react.createElement)(eyebrow ? 'h3' : isPageHeader ? 'h1' : 'h3', {
    className: `headline ${!eyebrow ? "headline--no-margin" : ""}`,
    'data-sb-field-path': 'headline',
    dangerouslySetInnerHTML: (0, _formatSpecialCharText.default)(headline)
  }, null), subhead && /*#__PURE__*/_react.default.createElement("div", {
    className: "subhead",
    "data-sb-field-path": "subhead"
  }, subhead)));
};
var _default = Header;
exports.default = _default;